export default __webpack_public_path__ + "static/media/circuit2.0f46831a.jpg";